import { Palette, Award, Users } from "lucide-react";
import { FounderSection } from "@/components/FounderSection";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 to-purple/5">
      <div className="container mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-brown mb-6">
            Nosotros
          </h1>
          <p className="text-xl text-brown/80 max-w-3xl mx-auto leading-relaxed">
            Somos un equipo apasionado por crear productos únicos hechos con amor y arte, 
            donde cada pieza cuenta una historia especial.
          </p>
        </div>

        <FounderSection />

        {/* Values */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-brown text-center mb-12">
            Nuestros Valores
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <Palette className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-xl font-bold text-brown mb-3">Creatividad</h3>
              <p className="text-brown/70">
                Cada producto es una expresión única de arte y creatividad, 
                diseñado para inspirar y emocionar.
              </p>
            </div>
            <div className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <Award className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-xl font-bold text-brown mb-3">Calidad</h3>
              <p className="text-brown/70">
                Utilizamos materiales de primera calidad y técnicas artesanales 
                para garantizar productos duraderos y hermosos.
              </p>
            </div>
            <div className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <Users className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-xl font-bold text-brown mb-3">Comunidad</h3>
              <p className="text-brown/70">
                Valoramos la conexión con nuestros clientes y la comunidad, 
                creando relaciones duraderas basadas en la confianza.
              </p>
            </div>
          </div>
        </div>

        {/* Story Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h2 className="text-3xl font-bold text-brown text-center mb-8">
            Nuestra Historia
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-brown/80 text-lg leading-relaxed mb-6">
              Vivi con Amor y Arte nació de la pasión por crear productos únicos que 
              transmitan emociones y marquen momentos especiales en la vida de las personas. 
              Lo que comenzó como un proyecto personal se ha convertido en un negocio 
              familiar dedicado a la excelencia artesanal.
            </p>
            <p className="text-brown/80 text-lg leading-relaxed mb-6">
              Cada producto que creamos lleva consigo horas de dedicación, atención al detalle 
              y mucho amor. Desde agendas personalizadas hasta productos digitales únicos, 
              nos especializamos en crear artículos que no solo son funcionales, sino que 
              también cuentan una historia.
            </p>
            <p className="text-brown/80 text-lg leading-relaxed">
              Hoy en día, seguimos comprometidos con nuestra visión original: crear productos 
              que conecten con el corazón de las personas y aporten belleza y significado 
              a su día a día.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;